import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
@Component({
  selector: 'app-bank-name',
  templateUrl: './../../../templates/forms/modals/bank-name.component.html',
})
export class BankNameComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  searchFields: any[] = ['BANK_NAME'];
  public searchString;

  dataObj: any;

  bankList: any[] = [];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "BankNameGrid"

  constructor(public langService: LangService, private comService: CommonService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.bankName, field: 'BANK_NAME', sortable: true, resizable: true, hide: false },
    ];
  }

  
  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    
    this.comService.getBankNamesFromVoucher().subscribe(result => {
      this.bankList = result.body;
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
